import React from 'react';
import PropTypes from 'prop-types';

import { PRIMARY_PURPLE } from '../../theme/colorConstants';

const TimezoneBadge = ({ timezone, sx }) => {
  if (!timezone) return null;

  const width = Math.max(23, timezone.length * 9 + 6);
  const height = 13;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: 'middle', flexShrink: 0, ...sx }}
    >
      <rect width={width} height={height} rx={height / 2} fill={PRIMARY_PURPLE[60]} />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fill="white"
        fontSize="9"
        fontWeight="600"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        {timezone}
      </text>
    </svg>
  );
};

TimezoneBadge.propTypes = {
  timezone: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
};

export default TimezoneBadge;
